import 'text-encoding-polyfill';
import { ANSWER_COLUMN_CLIENT_STATE_LATEST_VERSION, initAnswerColumnClientState, } from './answer-column-client-state/answer-column-client-state-init';
import { upgradeClientStateToLatestVersion as upgradeAnswerColumnClientState } from './answer-column-client-state/upgrader';
import { DEFAULT_AXIS_PROPERTIES, generateAxes, generateAxis, REQUIRED_AXIS_UPGRADE_PROPERTIES, } from './chart-client-state/chart-axis';
import { CHART_CLIENT_STATE_LATEST_VERSION, initChartClientState, RESPONSIVE_LAYOUT_PREFERENCE_TOGGLE_MAP, } from './chart-client-state/chart-client-state-init';
import { reuseClientState as reuseClientStateForChart } from './chart-client-state/chart-reuse-axis';
import { upgradeClientStateToLatestVersion as upgradeChartClientState } from './chart-client-state/upgrader';
import { getPivotStatePropsFromDXPivotState } from './chart-client-state/upgraders/v3-to-v4dot1';
import { CLIENT_STATE_KEYS, DEFAULT_ANSWER_COLUMN_PROPERTY, DEFAULT_CHART_COLUMN_PROPERTY_MAP, DEFAULT_CHART_SPECIFIC, DEFAULT_CHART_VIZ_PROPERTIES, DEFAULT_GRIDLINES, DEFAULT_HEADLINE_VIZ_PROPERTY, DEFAULT_PERCENTAGE_FORMAT, DEFAULT_PIVOT_SUMMARIES_STATE, getUpdatedFormatConfig, } from './client-state-type';
import { getUpdatedConditionalFormatting } from './conditional-formatting-upgrade-util';
import { HEADLINE_CLIENT_STATE_LATEST_VERSION, initHeadlineClientState, upgradeHeadlineClientState, } from './headline-client-state/headline-client-state-util';
import { initTableClientState, TABLE_CLIENT_STATE_LATEST_VERSION, } from './table-client-state/table-client-state-init';
import { reuseClientState as reuseClientStateForTable } from './table-client-state/table-reuse-client-state';
import { upgradeClientStateToLatestVersion as upgradeTableClientState } from './table-client-state/upgrader';
import { isClientStateValid } from './utils';
import { applyChartVisualOverrides } from './visual-overrides/chart-overrides-util';
import { applyHeadlineVisualOverrides } from './visual-overrides/headline-overrides-util';
import { applyTableVisualOverrides } from './visual-overrides/table-overrides-util';
export const upgradeClientStateForBlinkV2 = (vizModel) => {
    if (vizModel.typeName === 'ChartViz') {
        return upgradeChartClientState(vizModel);
    }
    if (vizModel.typeName === 'TableViz') {
        return upgradeTableClientState(vizModel);
    }
    if (vizModel.typeName === 'HeadlineViz') {
        return upgradeHeadlineClientState(vizModel);
    }
    if (vizModel.typeName === 'AnswerColumn') {
        return upgradeAnswerColumnClientState(vizModel);
    }
    return null;
};
export const initClientState = (vizModel) => {
    if (vizModel.typeName === 'ChartViz') {
        return initChartClientState(vizModel);
    }
    if (vizModel.typeName === 'TableViz') {
        return initTableClientState(vizModel);
    }
    if (vizModel.typeName === 'HeadlineViz') {
        return initHeadlineClientState(vizModel);
    }
    if (vizModel.typeName === 'AnswerColumn') {
        return initAnswerColumnClientState(vizModel);
    }
    return null;
};
export const applyVisualOverrides = (vizModel, columns = []) => {
    if (vizModel.typeName === 'ChartViz') {
        return applyChartVisualOverrides(vizModel, columns);
    }
    if (vizModel.typeName === 'TableViz') {
        return applyTableVisualOverrides(vizModel, columns);
    }
    if (vizModel.typeName === 'HeadlineViz') {
        return applyHeadlineVisualOverrides(vizModel);
    }
    return null;
};
export const isClientStateUpgradeRequired = (vizModel) => {
    if (vizModel.typeName === 'ChartViz') {
        return vizModel.vizProps.version !== CHART_CLIENT_STATE_LATEST_VERSION;
    }
    if (vizModel.typeName === 'TableViz') {
        return (vizModel.vizProps.tableVizPropVersion !==
            TABLE_CLIENT_STATE_LATEST_VERSION);
    }
    if (vizModel.typeName === 'HeadlineViz') {
        return (vizModel.vizProps.headlineVizPropVersion !==
            HEADLINE_CLIENT_STATE_LATEST_VERSION);
    }
    if (vizModel.typeName === 'AnswerColumn') {
        return (vizModel.vizProps.version !==
            ANSWER_COLUMN_CLIENT_STATE_LATEST_VERSION);
    }
    return false;
};
const reuseClientState = (vizModel) => {
    if (vizModel.typeName === 'ChartViz') {
        return reuseClientStateForChart(vizModel);
    }
    if (vizModel.typeName === 'TableViz') {
        return reuseClientStateForTable(vizModel);
    }
    if (vizModel.typeName === 'HeadlineViz') {
        return vizModel.vizProps;
    }
    return null;
};
export { getPivotStatePropsFromDXPivotState, getUpdatedConditionalFormatting, reuseClientState, DEFAULT_AXIS_PROPERTIES, REQUIRED_AXIS_UPGRADE_PROPERTIES, RESPONSIVE_LAYOUT_PREFERENCE_TOGGLE_MAP, DEFAULT_CHART_COLUMN_PROPERTY_MAP, getUpdatedFormatConfig, CLIENT_STATE_KEYS, DEFAULT_GRIDLINES, DEFAULT_PERCENTAGE_FORMAT, DEFAULT_ANSWER_COLUMN_PROPERTY, DEFAULT_CHART_SPECIFIC, DEFAULT_CHART_VIZ_PROPERTIES, DEFAULT_HEADLINE_VIZ_PROPERTY, DEFAULT_PIVOT_SUMMARIES_STATE, generateAxes, generateAxis, isClientStateValid, };
//# sourceMappingURL=index.js.map